import VoucherRedeemModal from "./voucher-redeem-modal";

export default VoucherRedeemModal;
